const words = {
  spanish: {
    title: "CONTACTO",
    name: "Nombre",
    email: "Correo Electrónico",
    description:
      "Valoramos su opinión y estamos aquí para atender cualquier consulta o inquietud que pueda tener. ¡No dude en contactarnos, estamos listos para brindarle el mejor servicio!",
    phone: "Teléfono",
    city: "Ciudad",
    message: "Mensaje",
    sendMessage: "Enviar",
    contact: "Contáctenos",
    address: "Primer restaurante a la izquierda",
    errName: "Por favor llene su nombre",
    errEmail: "Por favor introduzca un correo",
    errPhone: "Por favor denos un número de teléfono",
  },
  english: {
    title: "CONTACT",
    name: "Name",
    email: "Email",
    description:
      "We value your feedback and are here to address any questions or concerns you may have. Please don't hesitate to contact us, we are ready to provide you with the best service!",
    phone: "Phone Number",
    city: "City",
    message: "Message",
    sendMessage: "Send",
    contact: "Contact us",
    address: "First restaurant to your left",
    errName: "Please give us your name",
    errEmail: "Please give us an email",
    errPhone: "Please give us a phone number",
  },
};

export default words;
